import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { LegendItemList, type LegendItem } from "@/components/MapLegend";
import { structureType } from "@/config/structureType";

interface StructuresLegendProps {
	structures: Dryp.Structure[];
}

export const StructuresLegend = observer(({ structures }: StructuresLegendProps) => {
	const items = useMemo(() => {
		const counts = new Map<string, LegendItem>();
		for (const structureItem of structures) {
			const typeId = structureItem.type?.id;
			if (!typeId) continue;
			const style = structureType[typeId];
			if (!style) continue;
			const existing = counts.get(typeId);
			if (existing) {
				existing.count++;
			} else {
				counts.set(typeId, { label: style.label, color: style.bgColor, count: 1 });
			}
		}
		return [...counts.values()].sort((firstItem, secondItem) => secondItem.count - firstItem.count);
	}, [structures]);

	return <LegendItemList items={items} />;
});
